export const NODE_POSITIONS = {
  TEAM: {
    X: 100,
    Y_SPACING: 200,
  },
  USER: {
    X: 300,
    Y_SPACING: 50,
  },
} as const

export const NODE_STYLES = {
  borderRadius: '5px',
  padding: '10px',
} as const

export const DIAGRAM_DIMENSIONS = {
  height: 'calc(100vh - 80px)',
} as const

export const CONTROLS_POSITION = {
  bottom: 20,
  right: 20,
} as const

export const BACKGROUND_CONFIG = {
  gap: 16,
  size: 1,
} as const
